export default __webpack_public_path__ + "static/media/arrow-left-thin.d468277f.svg";